<template>
  <div class="box">
    <div :class="pcExport ? 'box-container bg' : 'box-container'" id="PDFID">
      <div class="title">{{ data.qtName }}得分：{{ data.score }}</div>
      <div class="score">
        {{ data.score }}
      </div>
      <ul
        class="lists"
        v-if="celiangResult.detailList && celiangResult.detailList.length > 0"
      >
        <li>
          <span class="left">总分</span>
          <span class="right">{{ data.score }}</span>
        </li>
        <li v-for="(item, index) in celiangResult.detailList" :key="index">
          <span class="left">{{ item.resultTitle }}</span>
          <span class="right">{{ item.score }}</span>
        </li>
      </ul>
      <h3 v-if="celiangResult.resultTitle">
        状态：{{ celiangResult.resultTitle }}
      </h3>
      <p
        v-if="celiangResult.resultContent"
        v-html="celiangResult.resultContent"
      ></p>
    </div>

    <div class="pcExport" @click="exportPdf()" v-if="pcExport">打印PDF</div>
    <Login v-if="loginTk" />
    <ChoiceCompany
      :choiceTk="choiceTk"
      :mobile="mobile"
      :companyList="companyList"
      v-if="choiceTk"
    />
  </div>
</template>
<script>
import ChoiceCompany from "../Integrated/components/choiceCompany.vue";
import Login from "../Integrated/components/login.vue";
import htmlToPdf from "../../utils/html2canvas";
export default {
  components: {
    Login,
    ChoiceCompany,
  },
  data() {
    return {
      loginTk: false,
      companyList: [],
      mobile: "",
      choiceTk: false,
      loginTrue: true,
      title: "",
      data: "",
      celiangResult: {},
      pcExport: false,
    };
  },
  mounted() {
    this.title = this.$route.query.from;
    if (
      sessionStorage.getItem("loginTk") &&
      sessionStorage.getItem("loginMsg")
    ) {
      this.loginTk = sessionStorage.getItem("loginTk");
    }
    document.title = this.title;
    if (
      sessionStorage.getItem("PcPhone") &&
      sessionStorage.getItem("PcCompanyId")
    ) {
      this.getList();
      this.pcExport = document.body.clientWidth > 750 ? true : false;
    } else {
      if (this.$route.query.phone && this.$route.query.companyId) {
        sessionStorage.setItem("PcPhone", this.$route.query.phone);
        sessionStorage.setItem("PcCompanyId", this.$route.query.companyId);
        this.getList();
        this.pcExport = true;
      } else if (
        !localStorage.getItem("IntegratedTitle") ||
        !localStorage.getItem("userInfo")
      ) {
        this.loginTrue = false;
        localStorage.setItem("IntegratedTitle", this.$route.query.from);
        this.loginTk = true;
        this.pcExport = false;
      } else {
        this.getList();
      }
    }
  },
  methods: {
    exportPdf() {
      htmlToPdf.download(document.getElementById("PDFID"), "量表报告");
    },
    getList() {
      this.loginTk = false;
      this.choiceTk = false;
      this.loginTrue = true;
      this.data = JSON.parse(decodeURIComponent(this.$route.query.report));
      this.celiangResult = JSON.parse(this.data.hxqMsgJson);
      console.log(this.celiangResult);
    },
  },
};
</script>
<style lang="less" scoped>
.box {
  padding: 0.5rem;
  min-height: 100%;
  background: #eff2f8;
}
.box-container {
  min-height: 1347px;
  margin: 0 auto;
  padding-top: 30px;
  box-sizing: border-box;
  // max-width: 944px;
  // margin: auto;
  // background: url(../../assets/Scale/reportBg.png);
}
.bg {
  width: 944px;
  padding: 0 30px;
  background: url(../../assets/Scale/reportBg.png);
}
.title {
  font-size: 0.5rem;
  color: #846dc0;
  margin-top: 0.2rem;
  font-weight: bold;
  margin-bottom: 0.3rem;
}
.score {
  margin: 0 0.2rem;
  padding: 0.5rem 0;
  background: url(../../assets/Scale/hxqScale.png) no-repeat;
  background-size: 100%;
  color: #fff;
  text-align: center;
  font-weight: bold;
  font-size: 1rem;
  box-sizing: border-box;
}
ul,
li {
  margin: 0;
  list-style: none;
  background: #fff;
}
ul {
  border: 1px solid #dadada;
  border-bottom: none;
  margin-top: 0.5rem;
}
li {
  display: flex;
  font-size: 0.26rem;
  text-align: center;
  line-height: 0.8rem;
  border-bottom: 1px solid #dadada;
  span.left {
    flex: 0.7;
    border-right: 1px solid #dadada;
  }
  span.right {
    flex: 0.3;
  }
}
h3 {
  font-size: 0.4rem;
  margin: 0.4rem 0 0;
}
p {
  font-size: 0.3rem;
  margin: 0.3rem 0;
}
.proposal {
  margin-top: 0.5rem;
  background: #fff;
  padding: 0.3rem 0.3rem 0.4rem;
  box-sizing: border-box;
  h4 {
    margin: 0;
    text-align: center;
    font-size: 0.3rem;
  }
  p {
    font-size: 0.26rem;
    margin: 0.2rem 0 0.3rem 0;
  }
  span {
    text-indent: 0.48rem;
    font-size: 0.24rem;
    margin: 0;
    line-height: 0.45rem;
    // margin-top: 0.2rem;
    display: block;
  }
}

.pcExport {
  position: absolute;
  font-size: 0.24rem;
  top: 0.5rem;
  right: 7%;
  background: #008d7d;
  color: #fff;
  padding: 0.1rem 0.2rem;
  border-radius: 0.1rem;
  cursor: pointer;
}
</style>